import React, { useState } from "react";
import Draggable from "react-draggable";

import { MenuClienteCSS } from "./styles";
import {
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBInputGroup,
} from "mdbreact";

import Fechar from "../../Images/fechar.png";
import { AiOutlineFileSearch } from "react-icons/ai";
import { RiHandCoinLine, RiBarChartBoxLine } from "react-icons/ri";
import { MdOutlineMessage } from "react-icons/md";
import { BsEasel } from "react-icons/bs";
import "jodit";
import "jodit/build/jodit.min.css";
import JoditEditor from "jodit-react";

// import { getProjeto, PostApi, PostApi2 } from "../services/auth";
import Carregando from "../../Componentes/Carregando";
import { URLBunge } from "../../Componentes/Config";
import { MudaVisibilidade } from "../../services/funcoes";

const TOKEN = localStorage.getItem("c_token");
const EMAIL_USUARIO = localStorage.getItem("c_email");
//ABA tabela PONTUAÇÕES
var PONTUACOES = {
  columns: [
    {
      label: "Pontos",
      field: "pontos",
      sort: "asc",
      width: 100,
    },
    {
      label: "Vinculado",
      field: "vinculado",
      sort: "asc",
      width: 100,
    },
    {
      label: "Bonus",
      field: "bonus",
      sort: "asc",
      width: 100,
    },
    {
      label: "Prêmios",
      field: "premios",
      sort: "asc",
      width: 100,
    },
    {
      label: "Expirados",
      field: "expirados",
      sort: "asc",
      width: 100,
    },
    {
      label: "Total",
      field: "total",
      sort: "asc",
      width: 100,
    },
  ],
};

var pontuacoesLeo = {
  columns: [
    {
      label: "Extrato",
      field: "tipo",
      sort: "asc",
      width: 100,
    },
    {
      label: "Pontos ganhos ou recebidos por transferidos",
      field: "pontos",
      sort: "asc",
      width: 70,
    },
    {
      label: "Bônus ganhos",
      field: "bonus",
      sort: "asc",
      width: 70,
    },
    {
      label: "Bônus transf. para outros*",
      field: "vinculado",
      sort: "asc",
      width: 70,
    },
    {
      label: "Pontos trocados",
      field: "premios",
      sort: "asc",
      width: 70,
    },
    {
      label: "Pontos expirados",
      field: "expirados",
      sort: "asc",
      width: 70,
    },
    {
      label: "Saldo disponível para troca",
      field: "total",
      sort: "asc",
      width: 80,
    },
  ],
};

var DETALHE_LEO = {
  columns: [
    {
      label: "Data",
      field: "data",
      sort: "asc",
      width: 100,
    },
    {
      label: "Descrição",
      field: "descricao",
      sort: "asc",
      width: 70,
    },
    {
      label: "Penca que fazia parte",
      field: "penca",
      sort: "asc",
      width: 70,
    },
    {
      label: "Categoria da Penca",
      field: "categoria",
      sort: "asc",
      width: 70,
    },
    {
      label: "Pontos",
      field: "pontos",
      sort: "asc",
      width: 70,
    },
  ],
};

var HIS_PENCA_LEO = {
  columns: [
    {
      label: "Penca",
      field: "penca",
      sort: "asc",
      width: 100,
    },
    {
      label: "Categoria da penca",
      field: "categoria",
      sort: "asc",
      width: 70,
    },
    {
      label: "Data de entrada na penca",
      field: "dataEntrada",
      sort: "asc",
      width: 70,
    },
    {
      label: "Data de saída da penca",
      field: "dataSaida",
      sort: "asc",
      width: 70,
    },
  ],
};

var HIS_COMPRAS_LEO = {
  columns: [
    {
      label: "Data",
      field: "data",
      sort: "asc",
      width: 100,
    },
    {
      label: "NF",
      field: "nota",
      sort: "asc",
      width: 70,
    },
    {
      label: "Penca",
      field: "penca",
      sort: "asc",
      width: 70,
    },
    {
      label: "Categoria da penca",
      field: "categoria",
      sort: "asc",
      width: 70,
    },
    {
      label: "Valor",
      field: "valor",
      sort: "asc",
      width: 70,
    },
    {
      label: "Pontos",
      field: "pontos",
      sort: "asc",
      width: 70,
    },
  ],
};

//ABA tabela PONTUAÇÕES TRANSACOES DE PONTOS
const TRANSACOES_PONTOS = {
  columns: [
    {
      label: "Data",
      field: "data",
      sort: "asc",
      width: 100,
    },
    {
      label: "Pontos",
      field: "pontos",
      sort: "asc",
      width: 100,
    },
    {
      label: "Tipo",
      field: "tipo",
      sort: "asc",
      width: 100,
    },
  ],
};

//ABA tabela PONTUAÇOES TRANSACOES DE BONUS
const TRANSACOES_BONUS = {
  columns: [
    {
      label: "Data",
      field: "data",
      sort: "asc",
      width: 100,
    },
    {
      label: "Pontos",
      field: "pontos",
      sort: "asc",
      width: 100,
    },
    {
      label: "Tipo",
      field: "tipo",
      sort: "asc",
      width: 100,
    },
  ],
};

//ABA tabela VALIDADE
const VALIDADE = {
  columns: [
    {
      label: "Mês",
      field: "mes",
      sort: "asc",
      width: 100,
    },
    {
      label: "Pontos",
      field: "pontos",
      sort: "asc",
      width: 100,
    },
  ],
};

//ABA tabela EXPIRADOS
const EXPIRADOS = {
  columns: [
    {
      label: "Mês",
      field: "mes",
      sort: "asc",
      width: 100,
    },
    {
      label: "Pontos",
      field: "pontos",
      sort: "asc",
      width: 100,
    },
  ],
};

//ABA tabela RESGATES EFETUADOS
const RESGATE = {
  columns: [
    {
      label: "Nº troca",
      field: "number",
      sort: "asc",
      width: 100,
    },
    {
      label: "Data da Troca",
      field: "data",
      sort: "asc",
      width: 100,
    },
    {
      label: "Feito pelo",
      field: "local",
      sort: "asc",
      width: 100,
    },
    {
      label: "Produto",
      field: "produto",
      sort: "asc",
      width: 100,
    },
    {
      label: "Pontos",
      field: "pontos",
      sort: "asc",
      width: 100,
    },
    {
      label: "Qtd",
      field: "qtd",
      sort: "asc",
      width: 100,
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
      width: 100,
    },
    {
      label: "Fornecedor",
      field: "fornecedor",
      sort: "asc",
      width: 100,
    },
    {
      label: "Entrega",
      field: "dataEntrega",
      sort: "asc",
      width: 100,
    },
  ],
};

//ABA tabela sms
const SMS = {
  columns: [
    {
      label: "Status",
      field: "status",
      sort: "asc",
      width: 100,
    },
    {
      label: "Celular",
      field: "celular",
      sort: "asc",
      width: 100,
    },
    {
      label: "Data do envio",
      field: "data",
      sort: "asc",
      width: 100,
    },
    {
      label: "Mensagem",
      field: "mensagem",
      sort: "asc",
      width: 100,
    },
  ],
};

//ABA TABELA AÇÕES
const ACOES = {
  columns: [
    {
      label: "Ação",
      field: "acao",
      sort: "asc",
      width: 100,
    },
    {
      label: "Data da participação",
      field: "dataparticipa",
      sort: "asc",
      width: 100,
    },
    {
      label: "Data de atualização",
      field: "dataatu",
      sort: "asc",
      width: 100,
    },
    {
      label: "Status",
      field: "status",
      sort: "asc",
      width: 100,
    },
  ],
  rows: [],
};

//ABA TABELA AÇÕES
const CONTATOS = {
  columns: [
    {
      label: "Email",
      field: "email",
      sort: "asc",
      width: 100,
    },
    {
      label: "Telefone",
      field: "telefone",
      sort: "asc",
      width: 180,
    },
    {
      label: "Recebido",
      field: "enviado",
      sort: "asc",
      width: 100,
    },
    {
      label: "Mensagem",
      field: "mensagem",
      sort: "asc",
      width: 100,
    },
    {
      label: "Data",
      field: "data",
      sort: "asc",
      width: 100,
    },
    {
      label: "Respostas",
      field: "respostas",
      sort: "asc",
      width: 100,
    },
  ],
};

function MenuCliente(props) {
  const [loading, setLoading] = useState(false);

  const [activeItem, setActiveItem] = useState("1");
  const [collapseID, setCollapseID] = useState("");

  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [modal44, setModal44] = useState(false);
  const [modal5, setModal5] = useState(false);
  const [modal6, setModal6] = useState(false);
  const [modal7, setmodal7] = useState(false);
  const [modal8, setModal8] = useState(false);
  const [modal9, setModal9] = useState(false);
  const [modal10, setModa10] = useState(false);
  const [modal88, setModa88] = useState(false);

  const [pontuacoes, setPontuacoes] = useState(0);
  const [ocorrencias, setOcorrencias] = useState([]);
  const [resumoLeo, setResumoLeo] = useState([]);
  const [detalheLeo, setDetalheLeo] = useState([]);
  const [HisComprasLeo, setHisComprasLeo] = useState([]);
  const [HisPencaLeo, setHisPencaLeo] = useState([]);
  const [HisCategoria, setHisCategoria] = useState([]);
  const [resumo, setResumo] = useState([]);
  const [validade, setValidade] = useState([]);
  const [bonnus, setBonnus] = useState([]);
  const [pontos, setPontos] = useState([]);
  const [expirados, setExpirados] = useState([]);
  const [sms, setSms] = useState([]);
  const [resgate, setResgate] = useState([]);
  const [faleConosco, setFaleConosco] = useState([]);
  const [validadeTotal, setValidadeTotal] = useState(0);
  const [expiradoTotal, setExpiradoTotal] = useState(0);
  const [ocorreciaSelecionada, setOcorreciaSelecionada] = useState({
    listaHistoricos: [],
  });
  const [usersDep, setUsersDep] = useState([]);
  const [UserEscolhido, setUserEscolhido] = useState(0);
  const [DepEscolhido, setDepEscolhido] = useState(0);
  const [departamentos, setDepartamentos] = useState([]);
  const [status, setStatus] = useState([]);
  const [StatusEscolhido, setStatusEscolhido] = useState(0);
  const [historicoMSG, setHistoricoMSG] = useState("");
  const [acoes, setAcoes] = useState([]);
  const [config, setConfig] = useState({
    readonly: false,
    uploader: {
      insertImageAsBase64URI: true,
    },
  });
  const [scripts, setScripts] = useState([]);
  const [SelectScript, setSelectScript] = useState("");
  const [activeDrags, setActiveDrags] = useState(0);

  const [respostaSelect, setRespostaSelect] = useState();

  const [setRespostaSelectD, respostaSelectD] = useState();
  const [idSelect, setIdSelect] = useState();
  const [Status, setStatuss] = useState();

  const [dataSelect, setDataSelect] = useState();
  const [MensagemSelect, setMensagemSelect] = useState();

  const [AtendenteSelect, setAtendenteSelect] = useState();
  const [dataRespostaSelect, setDataRespostaSelect] = useState();

  const dragHandlers = { onStart, onStop };

  function tabs(tab) {
    if (activeItem !== tab) {
      // setState({
      //   activeItem: tab
      // });
      setActiveItem(tab);
    }
  }

  function toggle(nr, ocorrencia = "") {
    console.log("***TOGGLE", nr, ocorrencia);

    switch (nr) {
      case 1:
        MudaVisibilidade("mdpontuacao");

        if (pontuacoes < 1) {
          CarregaPontuacao();
        } else {
          if (2329681 != 2334185) {
            MudaVisibilidade("mdpontuacao");
          } else {
            MudaVisibilidade("mdpontuacaoLeo");
          }
        }
        break;
      case 44:
        if (ocorrencias.length < 1) {
          CarregaOcorrencias();
        }
        MudaVisibilidade("mdocorrencia");
        break;
      case 3:
      case 4:
        break;
      case 5:
        if (resgate.length < 1) {
          extratoResgate();
        }
        MudaVisibilidade("mdresgates");
        break;
      case 6:
        if (sms.length < 1) {
          carregaSMS();
        }
        MudaVisibilidade("mdsms");
        break;
      case 7:
        if (acoes.length < 1) {
          CarregaAcoes();
        }
        MudaVisibilidade("mdacoes");
        break;
      case 8:
        if (faleConosco.length < 1) {
          faleConoscoFun();
        }
        MudaVisibilidade("mdfaleconosco");
        break;
      case 9:
        if (scripts.length < 1) {
          CarregaScripts();
        }
        MudaVisibilidade("mdscripts");
        break;
      case 444:
        if (ocorrencia != "") {
          selectOcorrencia(ocorrencia);
        }
        MudaVisibilidade("mdocorrencia444");
        break;
      case 9:
      case 10:
        console.log("nada acontece");
        break;
      case 88:
        if (ocorrencia == "responder") {
          responder();
        } else if (ocorrencia != "") {
          selectContato(ocorrencia);
        }
        MudaVisibilidade("md88");
        break;
    }
  }

  function toggleCollapse(collapseID) {
    setCollapseID((oldValue) => (oldValue !== collapseID ? collapseID : ""));
  }

  async function CarregaScripts() {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var resScripts = await fetch(
      `${URLBunge}/api/Scripts/BuscarScripts/${2329681}/true`,
      requestOptions
    ).then((response) => response.json());
    if (resScripts.sucesso) {
      setScripts(resScripts.listaScripts);
    }
    setLoading(false);
  }

  async function CarregaPontuacao() {
    setLoading(true);
    if (2329681 != 2334185) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + TOKEN);
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      var resPontuacao = await fetch(
        `${URLBunge}/api/Extrato/Pontuacao/${2329681}/${props.cpf}`,
        requestOptions
      )
        .then((response) => response.json())
        .catch((error) => setLoading(false));
      if (resPontuacao.bonnus.length > 0) {
        resPontuacao.bonnus.map((bon, i) => {
          var data = bon.data.split("T");
          bon.data = data[0].split("-").reverse().join("/") + " " + data[1];
          bon.pontos = bon.pontos.toLocaleString("pt-BR");
        });
      }
      if (resPontuacao.pontos.length > 0) {
        resPontuacao.pontos.map((pon, i) => {
          var data = pon.data.split("T");
          pon.data = data[0].split("-").reverse().join("/") + " " + data[1];
          pon.pontos = pon.pontos.toLocaleString("pt-BR");
        });
      }
      var validadeTotalPontos = 0;
      if (resPontuacao.validade.length > 0) {
        resPontuacao.validade.map((val, i) => {
          validadeTotalPontos = validadeTotalPontos + val.pontos;
          val.pontos = val.pontos.toLocaleString("pt-BR");
        });
      }
      var expiradoTotalPontos = 0;
      if (resPontuacao.expirados.length > 0) {
        resPontuacao.expirados.map((exp, i) => {
          expiradoTotalPontos = expiradoTotalPontos + exp.pontos;
          exp.pontos = exp.pontos.toLocaleString("pt-BR");
        });
      }
      if (resPontuacao.resumo != null) {
        setPontuacoes(1);
        setResumo([
          {
            pontos: resPontuacao.resumo.pontos.toLocaleString("pt-BR"),
            vinculado: resPontuacao.resumo.vinculado.toLocaleString("pt-BR"),
            bonus: resPontuacao.resumo.bonus.toLocaleString("pt-BR"),
            premios: resPontuacao.resumo.premios.toLocaleString("pt-BR"),
            expirados: resPontuacao.resumo.expirados.toLocaleString("pt-BR"),
            total: resPontuacao.resumo.total.toLocaleString("pt-BR"),
          },
        ]);
        setPontos(resPontuacao.pontos.length > 0 ? resPontuacao.pontos : []);
        setExpirados(
          resPontuacao.expirados.length > 0 ? resPontuacao.expirados : []
        );
        setBonnus(resPontuacao.bonnus.length > 0 ? resPontuacao.bonnus : []);
        setValidade(
          resPontuacao.validade.length > 0 ? resPontuacao.validade : []
        );
        setValidadeTotal(validadeTotalPontos);
        setExpiradoTotal(validadeTotalPontos);
      }
      // MudaVisibilidade("mdpontuacao");
    } else {
      BuscaDetalhe();
      BuscaHisPenca();
      BuscaHisCompra();
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + TOKEN);
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      var ExtratoResumoLeo = await fetch(
        `${URLBunge}/api/Extrato/ExtratoResumoLeo/${2329681}/${props.cpf}`,
        requestOptions
      ).then((response) => response.json());
      if (ExtratoResumoLeo.sucesso) {
        setPontuacoes(1);
        setResumoLeo([
          {
            tipo: "Penca",
            pontos:
              ExtratoResumoLeo.resumoPenca.pontosGanhos.toLocaleString("pt-BR"),
            bonus:
              ExtratoResumoLeo.resumoPenca.bonusGanhos.toLocaleString("pt-BR"),
            vinculado:
              ExtratoResumoLeo.resumoPenca.bonusParaOutros.toLocaleString(
                "pt-BR"
              ),
            premios:
              ExtratoResumoLeo.resumoPenca.pontosTrocados.toLocaleString(
                "pt-BR"
              ),
            expirados:
              ExtratoResumoLeo.resumoPenca.pontosExpirados.toLocaleString(
                "pt-BR"
              ),
            total:
              ExtratoResumoLeo.resumoPenca.saldoDisponivel.toLocaleString(
                "pt-BR"
              ),
          },
          {
            tipo: "Pessoal",
            pontos:
              ExtratoResumoLeo.resumoIndividual.pontosGanhos.toLocaleString(
                "pt-BR"
              ),
            bonus:
              ExtratoResumoLeo.resumoIndividual.bonusGanhos.toLocaleString(
                "pt-BR"
              ),
            vinculado:
              ExtratoResumoLeo.resumoIndividual.bonusParaOutros.toLocaleString(
                "pt-BR"
              ),
            premios:
              ExtratoResumoLeo.resumoIndividual.pontosTrocados.toLocaleString(
                "pt-BR"
              ),
            expirados:
              ExtratoResumoLeo.resumoIndividual.pontosExpirados.toLocaleString(
                "pt-BR"
              ),
            total: (
              ExtratoResumoLeo.resumoIndividual.pontosGanhos +
              ExtratoResumoLeo.resumoIndividual.bonusGanhos -
              ExtratoResumoLeo.resumoIndividual.pontosTrocados -
              ExtratoResumoLeo.resumoIndividual.pontosExpirados -
              ExtratoResumoLeo.resumoIndividual.bonusParaOutros
            ).toLocaleString("pt-BR"),
          },
        ]);
      }

      MudaVisibilidade("mdpontuacaoLeo");
    }

    setLoading(false);
  }

  async function BuscaDetalhe() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var responseDetalhe = await fetch(
      `${URLBunge}/api/Extrato/DetalhamentoPontosLeo/${2329681}/${props.cpf}`,
      requestOptions
    ).then((response) => response.json());
    if (responseDetalhe.sucesso === true) {
      var detalheLeoPontos = responseDetalhe.detalhamentoPontos;
      setDetalheLeo(detalheLeoPontos);
    }
  }

  async function BuscaHisPenca() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var responseHisPenca = await fetch(
      `${URLBunge}/api/Extrato/HistoricoPencaLeo/${2329681}/${props.cpf}`,
      requestOptions
    ).then((response) => response.json());
    if (responseHisPenca.sucesso === true) {
      var HistoricoPencaLeo = responseHisPenca.historicoPenca;
      setHisPencaLeo(HistoricoPencaLeo);
    }
  }

  async function BuscaHisCompra() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var responseHisCompra = await fetch(
      `${URLBunge}/api/Extrato/HistoricoComprasLeo/${2329681}/${props.cpf}`,
      requestOptions
    ).then((response) => response.json());
    if (responseHisCompra.sucesso === true) {
      var HisComprasLeoCompras = responseHisCompra.historicoCompras;
      setHisComprasLeo(HisComprasLeoCompras);
    }
  }

  async function extratoResgate() {
    setLoading(true);
    var resgateArray = [];
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var resResgate = await fetch(
      `${URLBunge}/api/Extrato/ExtratoResgate/${2329681}/${props.cpf}`,
      requestOptions
    ).then((response) => response.json());
    if (resResgate.sucesso) {
      resResgate.listaResgates.map((listaRes) => {
        var data = listaRes.dataTroca.split("T");
        var dataResgate = data[0].split("-").reverse().join("/");

        var dataEntrega = listaRes.dataEntrega;
        if (dataEntrega === null) {
          dataEntrega = " - ";
        } else {
          dataEntrega = listaRes.dataEntrega.split("T");
          dataEntrega = dataEntrega[0].split("-").reverse().join("/");
        }

        resgateArray.push({
          number: listaRes.numeroTroca,
          data: dataResgate,
          local: listaRes.origem,
          produto: listaRes.produto,
          pontos: listaRes.pontos,
          qtd: listaRes.qtd,
          status: listaRes.status,
          fornecedor: listaRes.fornecedor,
          dataEntrega: dataEntrega,
        });
      });
    }
    setResgate(resgateArray);
    setLoading(false);
  }

  async function faleConoscoFun() {
    setLoading(true);
    var faleConoscoArray = [];
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var resContato = await fetch(
      `${URLBunge}/api/FaleConosco/Buscar/${2329681}/${props.cpf}`,
      requestOptions
    ).then((response) => response.json());
    if (resContato.sucesso) {
      resContato.listaFaleConosco.map((fc) => {
        var dataFC = fc.split("T");
        dataFC = dataFC[0].split("-").reverse().join("/");
        faleConoscoArray.push({
          email: fc.email,
          telefone: fc.telefone,
          enviado: fc.recebido,
          mensagem: fc.mensagem,
          data: dataFC,
          respostas:
            fc.respostas === null ? (
              <MDBBtn
                color="info"
                onClick={() => toggle(88, fc)}
                className="fale"
              >
                Responder
              </MDBBtn>
            ) : (
              fc.respostas
            ),
        });
      });
    }
    setFaleConosco(faleConoscoArray);
    setLoading(false);
  }

  async function selectContato(contato) {
    // setState({
    //   respostaSelect: "",
    //   AtendenteSelect: "",
    //   dataRespostaSelect: ""
    // });

    setAtendenteSelect(AtendenteSelect);
    setDataRespostaSelect(dataRespostaSelect);

    var data = contato.data.split("T");
    var dataSelect =
      data[0].split("-").reverse().join("/") + " " + data[1].slice(0, 8);

    // setState({
    //   MensagemSelect: contato.mensagem,
    //   dataSelect: dataSelect,
    //   idSelect: contato.id
    // });

    setDataSelect(dataSelect);
    setMensagemSelect(contato.mensagem);

    if (
      contato.respostas != null &&
      contato.respostas != "" &&
      contato.respostas != "null"
    ) {
      var dataRes = contato.dataResposta.split("T");
      var dataRespostaSelect =
        dataRes[0].split("-").reverse().join("/") +
        " " +
        dataRes[1].slice(0, 8);

      // setState({
      //   respostaSelect: contato.respostas,
      //   AtendenteSelect: contato.respondeu,
      //   dataRespostaSelect: dataRespostaSelect
      // });

      setAtendenteSelect(contato.respondeu);
      setDataRespostaSelect(dataRespostaSelect);
    }

    if (contato.status == null) {
      var dadosAndamento = {
        // "idProjeto": getProjeto(),
        id: contato.id,
      };
      // await PostApi2("FaleConosco/EmAndamento", dadosAndamento);
    }
  }

  async function responder() {
    var dadosResponder = {
      // "idProjeto": getProjeto(),
      id: idSelect,
      resposta: respostaSelectD,
    };
    var retorno = {};
    // await PostApi("FaleConosco/Responder", dadosResponder);

    if (retorno.data.sucesso) {
      alert("Resposta enviada com sucesso");
      // setState({ respostaSelect: respostaSelectD });
      faleConoscoFun();
    } else {
      alert("Algum erro ocorreu");
    }
  }

  async function CarregaAcoes() {
    setLoading(true);
    var acoesArray = [];
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var resAcoes = await fetch(
      `${URLBunge}/api/Acoes/Listar/${2329681}/${props.cpf}`,
      requestOptions
    ).then((response) => response.json());
    if (resAcoes.sucesso) {
      resAcoes.listaAcoes.map((listaA, i) => {
        var dataParticipacao = "";
        if (listaA.dataParticipacao != null) {
          var data = listaA.dataParticipacao.split("T");
          dataParticipacao =
            data[0].split("-").reverse().join("/") + " " + data[1].slice(0, 8);
        }

        var dataAtualizacao = "";
        if (listaA.dataAtualizacao != null) {
          var data = listaA.dataAtualizacao.split("T");
          dataAtualizacao =
            data[0].split("-").reverse().join("/") + " " + data[1].slice(0, 8);
        }

        acoesArray.push({
          acao: listaA.acao,
          dataparticipa: dataParticipacao,
          dataatu: dataAtualizacao,
          status: listaA.status,
        });
      });
    }
    setAcoes(acoesArray);
    setLoading(false);
  }

  async function CarregaOcorrencias() {
    setLoading(true);
    var dadosOcorrencia = {
      // "idProjeto": getProjeto(),
      documento: props.cpf,
    };
    var resOcorrencias = {};
    // await PostApi("Ocorrencias/Listar", dadosOcorrencia);
    if (resOcorrencias.data.sucesso) {
      setOcorrencias(resOcorrencias.data.listaOcorrencias);
    }
    setLoading(false);
  }

  async function selectOcorrencia(idOcorrencia) {
    setLoading(true);
    buscaDep();
    buscaStu();
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var resOcorrencia = await fetch(
      `${URLBunge}/api/Ocorrencias/Buscar/${2329681}/${idOcorrencia}`,
      requestOptions
    ).then((response) => response.json());
    if (resOcorrencia.sucesso) {
      setOcorreciaSelecionada(resOcorrencia);
    }
    setLoading(false);
  }

  async function buscaStu() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var resStatus = await fetch(
      `${URLBunge}/api/Ocorrencias/BuscarStatus/${2329681}`,
      requestOptions
    ).then((response) => response.json());
    setStatus(resStatus.listaStatus);
  }

  async function buscaDep() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var resDepartamento = await fetch(
      `${URLBunge}/api/Usuarios/BuscaDep/${2329681}`,
      requestOptions
    ).then((response) => response.json());
    setDepartamentos(resDepartamento.listaDepartamentos);
  }

  async function selectDep(dep) {
    if (dep != "") {
      setDepEscolhido(dep);
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + TOKEN);
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      var users = await fetch(
        `${URLBunge}/api/Usuarios/BuscarUserDep/${dep}`,
        requestOptions
      ).then((response) => response.json());
      setUsersDep(users.listaUsuarios);
    }
  }

  async function EncaminhaOcorrencia() {
    if (DepEscolhido == "") {
      alert("Escolha um departamento");
      return;
    }
    if (UserEscolhido == "") {
      alert("Escolha um Usuario para encaminhar a ocorrencia");
      return;
    }
    if (StatusEscolhido == "") {
      alert("Escolha um status para a ocorrencia");
      return;
    }
    if (historicoMSG == "") {
      alert("Digite um comentario.");
      return;
    }
    var dadosOco = {
      // "idProjeto": getProjeto(),
      idOcorrencia: ocorreciaSelecionada.codigoOcorrencia,
      documento: ocorreciaSelecionada.clienteCPF,
      departamento: DepEscolhido,
      status: StatusEscolhido,
      userEncaminhado: UserEscolhido,
      historico: historicoMSG,
    };

    var retOco = {};
    // await PostApi("Ocorrencias/Encaminhar", dadosOco);

    if (retOco.data.sucesso) {
      alert("Ocorrencia Encaminhada com sucesso!");
      window.location = "/Home";
    }
  }

  async function carregaSMS() {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + TOKEN);
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    var resSMS = await fetch(
      `${URLBunge}/api/SMS/${2329681}/${props.cpf}`,
      requestOptions
    ).then((response) => response.json());
    var smsArray = [];
    resSMS.smsRetorno.forEach((s) => {
      var celular = "(" + s.celular.substring(2, 4) + ") " + s.celular.slice(4);
      var dataEnvio = "-";
      if (s.dataEnvio != null) {
        dataEnvio = s.dataEnvio.split("T");
        dataEnvio =
          dataEnvio[0].split("-").reverse().join("/") +
          " " +
          dataEnvio[1].slice(0, 8);
      }
      smsArray.push({
        status: s.status,
        celular: celular,
        data: dataEnvio,
        mensagem: s.mensagem,
      });
      setSms(smsArray);
    });
    setLoading(false);
  }

  function onStart() {
    setActiveDrags((oldValue) => ++oldValue);
  }

  function onStop() {
    setActiveDrags((oldValue) => --oldValue);
  }

  return (
    <MenuClienteCSS>
      {loading && <Carregando />}
      <nav id="menu-cliente">
        <a href="/ConsultarCadastros" className="links">
          <AiOutlineFileSearch />
          <small>Consulta de cadastros</small>
        </a>

        <div className="links" onClick={() => toggle(1)}>
          <RiBarChartBoxLine />
          <small>Pontuações</small>
        </div>

        <div className="links" onClick={() => toggle(5)}>
          <RiHandCoinLine />
          <small>Resgate</small>
        </div>

        <div className="links" onClick={() => toggle(6)}>
          <MdOutlineMessage />
          <small>SMS</small>
        </div>

        <div className="links" onClick={() => toggle(7)}>
          <BsEasel />
          <small>Ações</small>
        </div>

        {/* <a 
              onClick={async () => { await localStorage.setItem("fornada", "true"); window.location = "/Logout";}} 
              className="links"
            >
            <img src='' className="img" alt=""/>
            <small>Sair</small>
            </a> */}
      </nav>

      {/* MODAL DE PONTUAÇÃO */}
      <Draggable>
        <div id="mdpontuacao">
          <img
            src={Fechar}
            className="fecha"
            onClick={() => MudaVisibilidade("mdpontuacao")}
          />
          <section>
            <h2>Pontuação:</h2>
            <MDBNav className="nav-tabs mt-5">
              <MDBNavItem className={activeItem === "1" ? "ativo" : ""}>
                <MDBNavLink
                  to="#"
                  active={activeItem === "1"}
                  onClick={() => tabs("1")}
                  role="tab"
                >
                  Pontuação do Cliente
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem className={activeItem === "2" ? "ativo" : ""}>
                <MDBNavLink
                  to="#"
                  active={activeItem === "2"}
                  onClick={() => tabs("2")}
                  role="tab"
                >
                  Transações de Pontos
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem className={activeItem === "3" ? "ativo" : ""}>
                <MDBNavLink
                  to="#"
                  active={activeItem === "3"}
                  onClick={() => tabs("3")}
                  role="tab"
                >
                  Transações de Bônus
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem className={activeItem === "4" ? "ativo" : ""}>
                <MDBNavLink
                  to="#"
                  active={activeItem === "4"}
                  onClick={() => tabs("4")}
                  role="tab"
                >
                  Validade
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem className={activeItem === "5" ? "ativo" : ""}>
                <MDBNavLink
                  to="#"
                  active={activeItem === "5"}
                  onClick={() => tabs("5")}
                  role="tab"
                >
                  Expirados
                </MDBNavLink>
              </MDBNavItem>
            </MDBNav>

            <MDBTabContent activeItem={activeItem}>
              <MDBTabPane tabId="1" role="tabpanel">
                <MDBTable striped bordered>
                  <MDBTableHead columns={PONTUACOES.columns} />
                  <MDBTableBody rows={resumo} />
                </MDBTable>
              </MDBTabPane>

              <MDBTabPane tabId="2" role="tabpanel">
                <MDBTable striped bordered>
                  <MDBTableHead columns={TRANSACOES_PONTOS.columns} />
                  <MDBTableBody rows={pontos} />
                </MDBTable>
              </MDBTabPane>

              <MDBTabPane tabId="3" role="tabpanel">
                <MDBTable striped bordered>
                  <MDBTableHead columns={TRANSACOES_BONUS.columns} />
                  <MDBTableBody rows={bonnus} />
                </MDBTable>
              </MDBTabPane>

              <MDBTabPane tabId="4" role="tabpanel">
                <MDBTable striped bordered>
                  <MDBTableHead columns={VALIDADE.columns} />
                  <MDBTableBody rows={validade} />
                </MDBTable>
                <p>
                  <strong>
                    Total : {validadeTotal.toLocaleString("pt-BR")} pontos
                  </strong>
                </p>
              </MDBTabPane>

              <MDBTabPane tabId="5" role="tabpanel">
                <MDBTable striped bordered>
                  <MDBTableHead columns={EXPIRADOS.columns} />
                  <MDBTableBody rows={expirados} />
                </MDBTable>

                <p>
                  <strong>
                    Total : {expiradoTotal.toLocaleString("pt-BR")} pontos
                  </strong>
                </p>
              </MDBTabPane>
            </MDBTabContent>
          </section>
        </div>
      </Draggable>

      <Draggable>
        <div id="mdpontuacaoLeo">
          <img
            src={Fechar}
            className="fecha"
            onClick={() => MudaVisibilidade("mdpontuacaoLeo")}
          />
          <section>
            <h2>Pontuação:</h2>
            <MDBNav className="nav-tabs mt-5">
              <MDBNavItem className={activeItem === "1" ? "ativo" : ""}>
                <MDBNavLink
                  to="#"
                  active={activeItem === "1"}
                  onClick={() => tabs("1")}
                  role="tab"
                >
                  Pontuação
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem className={activeItem === "2" ? "ativo" : ""}>
                <MDBNavLink
                  to="#"
                  active={activeItem === "2"}
                  onClick={() => tabs("2")}
                  role="tab"
                >
                  Detalhamento dos pontos
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem className={activeItem === "3" ? "ativo" : ""}>
                <MDBNavLink
                  to="#"
                  active={activeItem === "3"}
                  onClick={() => tabs("3")}
                  role="tab"
                >
                  Histórico de Penca
                </MDBNavLink>
              </MDBNavItem>
              <MDBNavItem className={activeItem === "4" ? "ativo" : ""}>
                <MDBNavLink
                  to="#"
                  active={activeItem === "4"}
                  onClick={() => tabs("4")}
                  role="tab"
                >
                  Histórico de Compras
                </MDBNavLink>
              </MDBNavItem>
            </MDBNav>

            <MDBTabContent activeItem={activeItem}>
              <MDBTabPane tabId="1" role="tabpanel">
                <MDBTable striped bordered>
                  <MDBTableHead columns={pontuacoesLeo.columns} />
                  <MDBTableBody rows={resumoLeo} />
                </MDBTable>
              </MDBTabPane>

              <MDBTabPane tabId="2" role="tabpanel">
                <MDBTable striped bordered>
                  <MDBTableHead columns={DETALHE_LEO.columns} />
                  <MDBTableBody rows={detalheLeo} />
                </MDBTable>
              </MDBTabPane>

              <MDBTabPane tabId="3" role="tabpanel">
                <MDBTable striped bordered>
                  <MDBTableHead columns={HIS_PENCA_LEO.columns} />
                  <MDBTableBody rows={HisPencaLeo} />
                </MDBTable>
              </MDBTabPane>

              <MDBTabPane tabId="4" role="tabpanel">
                <MDBTable striped bordered>
                  <MDBTableHead columns={HIS_COMPRAS_LEO.columns} />
                  <MDBTableBody rows={HisComprasLeo} />
                </MDBTable>
              </MDBTabPane>
            </MDBTabContent>
          </section>
        </div>
      </Draggable>

      {/* CONSULTA DE OCORRENCIA */}
      <Draggable>
        <div id="mdocorrencia">
          <img
            src={Fechar}
            class="fecha"
            onClick={() => MudaVisibilidade("mdocorrencia")}
          />
          <section>
            <h2>Ocorrência:</h2>

            <MDBRow>
              <MDBCol md="12">
                <MDBInputGroup
                  size="lg"
                  containerClassName="mb-12"
                  prepend="Status de acesso"
                  className="mudi"
                  inputs={
                    <select
                      className="browser-default custom-select"
                      value={Status}
                    >
                      <option value="0">Aberto</option>
                      <option value="1">
                        Aguardando parecer do TI (o MELHOR DEPARTAMENTO)
                      </option>
                      <option value="2">Encerrado</option>
                    </select>
                  }
                />
              </MDBCol>
            </MDBRow>

            <div class="tbt">
              <MDBTable striped responsive>
                <MDBTableHead>
                  <tr>
                    <th>Nº</th>
                    <th>Abertura</th>
                    <th>Assunto</th>
                    <th>Aberto por</th>
                    <th>Encaminhada</th>
                    <th>Status</th>
                    <th>Encerrada</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {ocorrencias.length > 0 ? (
                    ocorrencias.map((oco, i) => {
                      var data = oco.abertura.split("T");
                      var dataAbertura = data[0].split("-").reverse().join("/");
                      var dataEncerrada = "Ocorrencia aberta";
                      if (oco.encerrada != null) {
                        var dataEn = oco.encerrada.split("T");
                        dataEncerrada = dataEn[0]
                          .split("-")
                          .reverse()
                          .join("/");
                      }
                      return (
                        <tr>
                          <td>
                            {oco.numero > 0 ? oco.numero : oco.codigoOcorrencia}
                          </td>
                          <td>{dataAbertura}</td>
                          <td>
                            <strong>
                              <a
                                onClick={() =>
                                  toggle(444, oco.codigoOcorrencia)
                                }
                              >
                                {oco.assunto}
                              </a>
                            </strong>
                          </td>
                          <td>{oco.abertoPor}</td>
                          <td>{oco.encaminhada}</td>
                          <td>{oco.status}</td>
                          <td>{dataEncerrada}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="7">Nenhuma Ocorrência encontrada</td>
                    </tr>
                  )}
                </MDBTableBody>
              </MDBTable>
            </div>
          </section>
        </div>
      </Draggable>

      {/*  MODAL DE DETALHE DA OCORRENCIA */}
      <Draggable>
        <div id="mdocorrencia444">
          <img
            src={Fechar}
            class="fecha"
            onClick={() => MudaVisibilidade("mdocorrencia444")}
          />
          <section>
            <h2>Detalhe da Ocorrência:</h2>

            <MDBRow>
              <div data-test="col" class="col-md-12 sep">
                <span class="blockquote bq-title bq-warning">
                  Dados de consulta
                </span>
              </div>
              <MDBCol md="2">
                <MDBInput
                  label="Código"
                  outline
                  size="lg"
                  value={
                    ocorreciaSelecionada.codigoAtendimento > 0
                      ? ocorreciaSelecionada.codigoAtendimento
                      : ocorreciaSelecionada.codigoOcorrencia
                  }
                />
              </MDBCol>

              <MDBCol md="4">
                <MDBInput
                  label="Nome"
                  outline
                  size="lg"
                  value={ocorreciaSelecionada.cliente}
                />
              </MDBCol>

              <MDBCol md="3">
                <MDBInput
                  label="CPF"
                  outline
                  size="lg"
                  value={ocorreciaSelecionada.clienteCPF}
                />
              </MDBCol>

              <MDBCol md="3">
                <MDBInput
                  label="Tel Celular"
                  outline
                  size="lg"
                  value={ocorreciaSelecionada.clienteTelefone}
                />
              </MDBCol>

              <MDBCol md="6">
                <MDBInput
                  label="Aberto por"
                  outline
                  size="lg"
                  value={ocorreciaSelecionada.abertoPor}
                />
              </MDBCol>

              <MDBCol md="3">
                <MDBInput
                  label="Motivo"
                  outline
                  size="lg"
                  value={ocorreciaSelecionada.motivo}
                />
              </MDBCol>

              <MDBCol md="3">
                <MDBInput
                  label="Status"
                  outline
                  size="lg"
                  value={ocorreciaSelecionada.status}
                />
              </MDBCol>

              <div data-test="col" class="col-md-12 sep">
                <span class="blockquote bq-title bq-warning">
                  Histórico da Ocorrência
                </span>
              </div>
              <div className="clear"></div>
              <br />

              <MDBCol md="12">
                <MDBTable striped>
                  <MDBTableHead>
                    <tr>
                      <th>Codigo</th>
                      <th>Quem abriu</th>
                      <th>Foi encaminhado para</th>
                      <th>Data</th>
                      <th>Status</th>
                      <th>Comentário</th>
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                    {ocorreciaSelecionada.listaHistoricos.length > 0 ? (
                      ocorreciaSelecionada.listaHistoricos.map(
                        (listaHis, i) => {
                          var data = listaHis.data.split("T");
                          var dataMovimentacao = data[0]
                            .split("-")
                            .reverse()
                            .join("/");
                          return (
                            <tr>
                              <td>{listaHis.codigo}</td>
                              <td>{listaHis.userInicial}</td>
                              <td>{listaHis.userEncaminahdo}</td>
                              <td>{dataMovimentacao}</td>
                              <td>{listaHis.status}</td>
                              <td>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: listaHis.mensagem,
                                  }}
                                ></div>
                              </td>
                            </tr>
                          );
                        }
                      )
                    ) : (
                      <tr>
                        <td colSpan="6">Sem Historico</td>
                      </tr>
                    )}
                  </MDBTableBody>
                </MDBTable>
              </MDBCol>
              <div className="clear"></div>
              <br />
              {ocorreciaSelecionada.status != "ENCERRADA" ? (
                <div class="row" style={{ margin: 0 }}>
                  <div data-test="col" class="col-md-12 sep">
                    <span class="blockquote bq-title bq-warning">
                      Adicionar/Encaminhar Comentários
                    </span>
                  </div>
                  <div className="clear"></div>
                  <br />

                  <MDBCol md="4">
                    <div className="clear"></div>
                    <MDBInputGroup
                      size="lg"
                      containerClassName="mb-12"
                      prepend="Departamento"
                      inputs={
                        <select
                          className="browser-default custom-select"
                          onChange={(e) => selectDep(e.target.value)}
                        >
                          <option value=""> Selecione um Departamento</option>
                          {departamentos.map((dep, i) => {
                            return <option value={dep.id}> {dep.nome}</option>;
                          })}
                        </select>
                      }
                    />
                  </MDBCol>

                  <MDBCol md="4">
                    <div className="clear"></div>
                    <MDBInputGroup
                      size="lg"
                      containerClassName="mb-12"
                      prepend="Encaminhar"
                      inputs={
                        <select
                          className="browser-default custom-select"
                          onChange={(e) => setUserEscolhido(e.target.value)}
                        >
                          <option value=""> Selecione o User</option>
                          {usersDep.map((usu, i) => {
                            return <option value={usu.id}> {usu.nome}</option>;
                          })}
                        </select>
                      }
                    />
                  </MDBCol>

                  <MDBCol md="4" style={{ marginTop: "15px" }}>
                    <MDBInputGroup
                      size="lg"
                      containerClassName="mb-12"
                      prepend="Status de acesso"
                      inputs={
                        <select
                          className="browser-default custom-select"
                          onChange={(e) => setStatusEscolhido(e.target.value)}
                        >
                          <option value=""> Selecione o Status</option>
                          {status.map((stu, i) => {
                            return (
                              <option value={stu.id}> {stu.descricao}</option>
                            );
                          })}
                        </select>
                      }
                    />
                  </MDBCol>

                  <MDBCol md="12">
                    <label htmlFor="exampleFormControlTextarea1">
                      Adicionar Comentários
                    </label>
                    <JoditEditor
                      value={historicoMSG}
                      config={config}
                      className="textHtml"
                      onChange={(e) => setHistoricoMSG(e)}
                    />
                  </MDBCol>
                </div>
              ) : (
                <div></div>
              )}
            </MDBRow>
          </section>
        </div>
      </Draggable>

      {/* MODAL RESGATES */}
      <Draggable handle="strong" {...dragHandlers}>
        <div id="mdresgates" className="box no-cursor">
          <img
            src={Fechar}
            class="fecha"
            onClick={() => MudaVisibilidade("mdresgates")}
          />
          <section>
            <strong className="cursor">
              <div>Resgates efetuados pelo cliente:</div>
            </strong>

            <MDBTable striped bordered>
              <MDBTableHead columns={RESGATE.columns} />
              <MDBTableBody rows={resgate} />
            </MDBTable>
          </section>
        </div>
      </Draggable>

      {/* MODAL SMS */}
      <Draggable handle="strong" {...dragHandlers}>
        <div id="mdsms" className="box no-cursor">
          <img
            src={Fechar}
            class="fecha"
            onClick={() => MudaVisibilidade("mdsms")}
          />
          <section>
            <strong className="cursor">
              <div>Sms enviados ao cliente:</div>
            </strong>

            <MDBTable striped bordered>
              <MDBTableHead columns={SMS.columns} />
              <MDBTableBody rows={sms} />
            </MDBTable>
          </section>
        </div>
      </Draggable>

      {/* MODAL ACOES */}
      <Draggable>
        <div id="mdacoes">
          <img
            src={Fechar}
            class="fecha"
            onClick={() => MudaVisibilidade("mdacoes")}
          />
          <section>
            <h2>Ações que o cliente participou:</h2>

            <div className="modil">
              <MDBTable striped bordered>
                <MDBTableHead columns={ACOES.columns} />
                <MDBTableBody rows={acoes} />
              </MDBTable>
            </div>
          </section>
        </div>
      </Draggable>

      {/* MODAL CONTATO */}
      <Draggable>
        <div id="mdfaleconosco">
          <img
            src={Fechar}
            class="fecha"
            onClick={() => MudaVisibilidade("mdfaleconosco")}
          />
          <section>
            <h2>Mensagem enviadas pelo Cliente:</h2>

            <MDBTable striped bordered>
              <MDBTableHead columns={CONTATOS.columns} />
              <MDBTableBody rows={faleConosco} />
            </MDBTable>
          </section>
        </div>
      </Draggable>

      {/* MODAL Scripots */}
      <Draggable>
        <div id="mdscripts">
          <img
            src={Fechar}
            class="fecha"
            onClick={() => MudaVisibilidade("mdscripts")}
          />
          <section>
            <h2>Meus Scripts:</h2>
            <MDBCol md="12">
              <div id="lista">
                <MDBTable>
                  <MDBTableBody>
                    {scripts.length > 0 ? (
                      scripts.map((scr, i) => {
                        if (scr.status) {
                          return (
                            <tr key={i}>
                              <td>
                                {" "}
                                <a onClick={() => setSelectScript(scr.script)}>
                                  {scr.titulo}
                                </a>
                              </td>
                            </tr>
                          );
                        }
                      })
                    ) : (
                      <div> Nenhum Script encontrado</div>
                    )}
                  </MDBTableBody>
                </MDBTable>
              </div>

              <div
                dangerouslySetInnerHTML={{ __html: SelectScript }}
                className="contscript"
              ></div>
            </MDBCol>
          </section>
        </div>
      </Draggable>

      <Draggable>
        <div id="md88">
          <img
            src={Fechar}
            class="fecha"
            onClick={() => MudaVisibilidade("md88")}
          />
          <section>
            <h2>Responder:</h2>
            <MDBCol md="12">
              <form action="">
                <MDBRow>
                  <MDBCol md="12">
                    <div className="ballon usuario">
                      <div className="user usr">
                        {" "}
                        Cliente {dataSelect}
                        <img src="" title="Você" className="img" />
                      </div>
                      <p>{MensagemSelect}</p>
                    </div>
                  </MDBCol>
                  {respostaSelect != "" ? (
                    <MDBCol md="12">
                      <div className="ballon atendente">
                        <div className="user atd">
                          {" "}
                          {AtendenteSelect + " " + dataRespostaSelect}
                          <img src="" title="Atendente" className="img" />
                        </div>
                        <p>{respostaSelect}</p>
                      </div>
                    </MDBCol>
                  ) : (
                    <MDBCol md="12">
                      <MDBCol md="12">
                        <textarea
                          type="text"
                          id="defaultFormContactMessageEx"
                          onChange={(e) => setRespostaSelectD(e.target.value)}
                          className="form-control"
                          rows="5"
                        />
                      </MDBCol>
                      <MDBCol md="4">
                        <button
                          class="btn btn-default waves-effect waves-light"
                          onClick={() => toggle(88, "responder")}
                          type="button"
                        >
                          Responder o cliente
                        </button>
                      </MDBCol>
                    </MDBCol>
                  )}
                </MDBRow>
              </form>
            </MDBCol>
          </section>
        </div>
      </Draggable>
      <div id="whats">
        <a href="https://wa.me/551129288801 " target="_blank">
          <img src="" className="img" title="Whats Bunge" />
        </a>
      </div>
    </MenuClienteCSS>
  );
}

export default MenuCliente;
